<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<!--처리상태-->
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001043') }}</span>
				</div>
			</div>

			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<th class="col-1">PWA No.</th>
							<td class="col-1"><el-input v-model="pwaNo" readOnly /></td>
							<!--처리단계-->
							<th class="col-1">{{ getMessage_('QWCC000963') }}</th>
							<td class="col-1">
								<el-input v-model="prcsStepNm" readOnly />
							</td>
							<!--신청일-->
							<th class="col-1">{{ getMessage_('QWCC000979') }}</th>

							<td class="col-1">
								<el-input v-model="aplcDd" readOnly />
							</td>
							<!--확정일-->
							<th class="col-1">{{ getMessage_('QWCC000980') }}</th>
							<td class="col-1">
								<el-input v-model="dcsnDd" readOnly />
							</td>

							<!--pwa 신청자-->
							<th class="col-1">{{ getMessage_('QWCC002089') }}</th>
							<td class="col-1">
								<el-input v-model="aplcNm" readOnly />
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../../store/helpers';
import { convertNvl } from '@/qmsUtils/'; //공통함수 import
import moment from 'moment';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {},
	data() {
		return {
			pwaNo: '', //pwqNo
			prcsStepNm: '',
			prcStep: '',
			aplcDd: '',
			dcsnDd: '',
			aplcId: '',
			aplcNm: ''
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		chgFlag() {
			return this.getIsSaveFlag_;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		setProcessInfo() {
			this.pwaNo = this.pwaApcnPopUp.pwaNo; // PWANO
			this.prcStep = this.pwaApcnPopUp.prcStep; //처리단계코드
			this.prcsStepNm = this.pwaApcnPopUp.prcsStepNm; // 처리단계명
			this.aplcDd = this.pwaApcnPopUp.aplcDd; //신청일
			this.dcsnDd = this.pwaApcnPopUp.dcsnDd; //확정일
			this.aplcId = this.pwaApcnPopUp.aplcId; //신청자Id
			this.aplcNm = this.pwaApcnPopUp.aplcNm; //신청자
		}
	},
	async created() {
		//스토어에서 값을 가져와서 셋팅한다.

		this.pwaNo = this.pwaApcnPopUp.pwaNo; // PWANO
		this.prcStep = this.pwaApcnPopUp.prcStep; //처리단계코드
		this.prcsStepNm = this.pwaApcnPopUp.prcsStepNm; // 처리단계명
		this.aplcDd = this.pwaApcnPopUp.aplcDd; //신청일
		this.dcsnDd = this.pwaApcnPopUp.dcsnDd; //확정일
		this.aplcId = this.pwaApcnPopUp.aplcId; //신청자Id
		this.aplcNm = this.pwaApcnPopUp.aplcNm; //신청자
	},
	watch: {
		chgFlag() {
			// true 일때 해당 data를 store에 담는 작업 시작
			if (this.getIsSaveFlag_) {
				this.setStateApcnSave_({ key: 'pwaNo', value: convertNvl(this.pwaNo, '') }); // PWANO
				this.setStateApcnSave_({ key: 'prcStep', value: convertNvl(this.prcStep, '') }); //처리단계코드
				this.setStateApcnSave_({ key: 'prcsStepNm', value: convertNvl(this.prcsStepNm, '') }); // 처리단계명
				this.setStateApcnSave_({ key: 'aplcId', value: convertNvl(this.aplcId, '') }); // 신청자
				this.setStateApcnSave_({ key: 'aplcNm', value: convertNvl(this.aplcNm, '') }); // 신청자
				//this.setStateApcnSave_({ key: 'aplcDd', value: moment(convertNvl(this.aplcDd, '')).format('YYYYMMDD') }); //신청일
				//this.setStateApcnSave_({ key: 'dcsnDd', value: moment(convertNvl(this.dcsnDd, '')).format('YYYYMMDD') }); //확정일
			}
		}
	}
};
</script>
<style>
.sf-input-group-wrapper__label {
	color: aqua;
}
.search-option-wrapper__normal {
	position: relative;
}
.search-icon {
	color: var(--color-default);
	font-size: 1.5rem;
	position: absolute;
	right: 0;
	cursor: pointer;
	top: -3px;
}
</style>
